import React from 'react';

export const LoginSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32}>
    <title>{'98A7A2B2-9C02-4440-AF2B-A26A6CCD8FB1'}</title>
    <path
      fill="#333"
      fillRule="nonzero"
      d="M16 26a3 3 0 0 1-3-3v-1a1 1 0 0 1 2 0v1a1 1 0 0 0 1 1h7a1 1 0 0 0 .993-.883L24 23V9a1 1 0 0 0-.883-.993L23 8h-7a1 1 0 0 0-1 1v1a1 1 0 0 1-2 0V9a3 3 0 0 1 3-3h7a3 3 0 0 1 2.995 2.824L26 9v14a3 3 0 0 1-2.824 2.995L23 26h-7Zm1.613-14.79.094.083 4 4 .042.044.008.01.03.036-.008-.009.025.03c.018.025.034.05.05.075l.021.037c.011.02.022.04.031.06l.023.053A.988.988 0 0 1 22 16l-.004.085-.007.064a1.083 1.083 0 0 1-.06.222l-.023.052a1.018 1.018 0 0 1-.126.202l-.073.082-4 4a1 1 0 0 1-1.497-1.32l.083-.094L18.585 17H8a1 1 0 0 1-.117-1.993L8 15h10.585l-2.292-2.293a1 1 0 0 1-.083-1.32l.083-.094a1 1 0 0 1 1.32-.083Z"
    />
  </svg>
);
